import React, { useState, useEffect } from 'react';
import routes from '../utils/paths';

function Home({ user }) {
    const [timeLeft, setTimeLeft] = useState(0);
    const [qrImage, setQrImage] = useState('');
    const [qrDate, setQrDate] = useState('');
    const [loaded, setIsLoaded] = useState(false);

    const resetQr = () => {
        if (user.is_guest) {
            requestQrGuest();
        } else {
            requestQrUser();
        }
        setTimeLeft(10)
    }

    async function requestQrGuest() {
        let guest_id = sessionStorage.getItem('guest');
        await fetch(routes.domain.url + routes.apis.guest_qr + '?guest_id='+guest_id, {
            method: 'GET', // El método HTTP es GET
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Error en la respuesta de la API');
                }
                return response.json();  // Convertir la respuesta a formato JSON
            })
            .then((responseJson) => {
                console.log('Datos obtenidos:', responseJson);  // Usar los datos obtenidos
                setQrImage(responseJson.qr)
                setQrDate(responseJson.message)
                setTimeLeft(10)
                return;
            })
            .catch((error) => {
                console.error('Error al obtener los datos:', error);  // Manejo de errores
            });

    }

    async function requestQrUser() {
        let token = sessionStorage.getItem('user');
        await fetch(routes.domain.url + routes.apis.user_qr, {
            method: 'GET', // El método HTTP es GET
            headers: {
                'Authorization': 'Bearer ' + token  // Aquí agregas tu Bearer token
            },
        })
            .then((response) => {
                if (!response.ok) {
                    throw new Error('Error en la respuesta de la API');
                }
                return response.json();  // Convertir la respuesta a formato JSON
            })
            .then((responseJson) => {
                console.log('Datos obtenidos:', responseJson);  // Usar los datos obtenidos
                setQrImage(responseJson.qr)
                setQrDate(responseJson.message)
                setTimeLeft(10)
                return;
            })
            .catch((error) => {
                console.error('Error al obtener los datos:', error);  // Manejo de errores
            });

    }


    useEffect(() => {
        // Si el tiempo restante es 0, no hacemos nada
        if (timeLeft === 0) {
            setQrImage('');
            return;
        }

        // Crea un intervalo que actualiza el estado cada segundo
        const timer = setInterval(() => {
            setTimeLeft((prevTime) => prevTime - 1);
        }, 1000);

        // Limpia el intervalo cuando el componente se desmonta o el estado cambia
        return () => clearInterval(timer);
    }, [timeLeft]);



    useEffect(() => {
        if (user.is_guest) {
            requestQrGuest();
        } else {
            requestQrUser();
        }

        setIsLoaded(true);
        return () => {
            console.log("Out of view")
        };
    }, []);
    return (
        <div
            className="flex flex-col justify-center items-center flex-grow px-4"
        >
            {/* Foto de Perfil */}
            <div className="w-24 h-24 mb-4">
                <img
                    src={user.profile_photo_url ?? 'https://via.placeholder.com/150'}
                    alt="Foto de perfil"
                    className="w-full h-full object-cover rounded-full border-4 border-gray-100 shadow-md"
                />
            </div>

            {/* Nombre del Usuario */}
            <h1 className="text-xl font-semibold text-gray-900">
                {user.nick_name ?? user.fullname}
            </h1>

            {/* Botones */}
            {loaded ? <div className="flex space-x-4 mt-4">
                <button className="px-4 py-2 bg-white text-gray-700 rounded-full shadow-md border border-gray-300 hover:bg-gray-200" onClick={() => timeLeft <= 0 && resetQr()}>
                    Recargar {timeLeft ? 'en ' + timeLeft : 'ahora'}
                </button>
            </div> : <div></div>}

            {/* Código QR */}
            {qrImage ?
                <>
                    <div className="mt-6">
                        <img
                            src={qrImage}
                            alt="Código QR"
                            className="w-48 h-48 border border-gray-400"
                        />
                    </div>

                    <p className="text-gray-600 text-sm mt-2">
                        {qrDate}
                    </p>
                </>
                : <span></span>}
        </div>

    );
}

export default Home;
